import { render } from "./RecommendApp.vue?vue&type=template&id=2a4ff9be"
import script from "./RecommendApp.vue?vue&type=script&lang=js"
export * from "./RecommendApp.vue?vue&type=script&lang=js"

import "./RecommendApp.vue?vue&type=style&index=0&id=2a4ff9be&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__